import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';
import { useUser } from '@/modules/viewer/composables/useUser';

export const useAddon = () => {
  const entitlementsStore = useEntitlementsStore();
  const organizationStore = useOrganizationStore();
  const { trial, isNewPlanFor2025 } = storeToRefs(organizationStore);
  const { isCurrentItemOwner } = useUser();

  const hasAiAddon = computed(() => {
    return isCurrentItemOwner.value && entitlementsStore.can('aiSummary');
  });

  const isAiAddonTrial = computed(() => {
    return trial?.value === true && entitlementsStore.can('aiSummary');
  });

  // True for new 2025 plan users without AI access (e.g. Share plan).
  // Driven by the entitlement service, not a hardcoded plan name check.
  // These users should see a plan upgrade upsell, not the legacy AI addon purchase upsell.
  const isNewPlanWithoutAi = computed(() => {
    return isNewPlanFor2025.value && !entitlementsStore.can('aiSummary');
  });

  return { hasAiAddon, isAiAddonTrial, isNewPlanWithoutAi };
};
